import React, { useEffect, useRef, useState } from "react";

/**
 * Animated counter that eases up to `value` over ~600ms when it first appears
 * in the viewport (via IntersectionObserver).
 */
export default function CountUp({ value = 0, duration = 700, className = "", testId }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const startT = performance.now();
          const target = Number(value) || 0;
          const step = (now) => {
            const p = Math.min(1, (now - startT) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setDisplay(Math.round(target * eased));
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [value, duration]);

  return <span ref={ref} className={className} data-testid={testId}>{display}</span>;
}
